import { Box, Typography, IconButton } from '@material-ui/core'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import PhenotypeFilter from 'src/views/VariantsView/Toolbar/FiltersPanelMenu/PhenotypeFilter'
import HPOFilter from 'src/views/VariantsView/Toolbar/FiltersPanelMenu/HPOFilter'
import SamplesFilter from 'src/components/SamplesFilter'
import PanelsFilter from 'src/components/PanelsFilter'

const FilterWidgetContainer = styled(motion.div)`
  position: fixed;
  bottom: 30px;
  right: calc(27vw);
  z-index: 1000;
  width: 30vw;
  min-width: 300px;
  max-width: 400px;
  height: auto;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: ${(props) => props.theme.customShadows.z16};
  background-color: ${(props) => props.theme.palette.background.paper};
  overflow: hidden;
`

const FilterWidgetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing(2)};
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`

export default function FilterWidget({
  type,
  title,
  onClose,
  isDarkMode,
  // Disease specific props
  phenotypes,
  setPhenotypes,
  // HPO specific props
  hpoTerms,
  setHpoTerms,
  // Samples specific props
  selectedSamples,
  setSelectedSamples,
  // Panels specific props
  selectedPanels,
  setSelectedPanels,
}) {
  const renderFilter = () => {
    if (type === 'disease') {
      return <PhenotypeFilter phenotypes={phenotypes} setPhenotypes={setPhenotypes} showInheritance={false} />
    }
    if (type === 'samples') {
      return <SamplesFilter selectedSamples={selectedSamples} setSelectedSamples={setSelectedSamples} />
    }
    if (type === 'panels') {
      return <PanelsFilter selectedPanels={selectedPanels} setSelectedPanels={setSelectedPanels} />
    }
    return <HPOFilter hpoTerms={hpoTerms} setHpoTerms={setHpoTerms} />
  }

  return (
    <FilterWidgetContainer
      initial={{ opacity: 0, scale: 0.95, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95, y: 20 }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30,
        duration: 0.3,
      }}
      isDarkMode={isDarkMode}
      position={type}
    >
      <FilterWidgetHeader>
        <Typography variant="subtitle1">{title}</Typography>
        <IconButton size="medium" onClick={onClose}>
          <ExpandMoreIcon fontSize="medium" />
        </IconButton>
      </FilterWidgetHeader>
      <Box sx={{ p: 2, overflow: 'auto', maxHeight: 'calc(80vh - 64px)' }}>{renderFilter()}</Box>
    </FilterWidgetContainer>
  )
}
